import { Injectable } from '@angular/core';

const NUM_MS_IN_ONE_SS = 1000;

@Injectable()
export class DateTimeService {
	dst: boolean;
	defaultDateTime: number;

	constructor() {
		this.dst = false;
		this.defaultDateTime = new Date().getTime();
	}

	public isDST(timestamp: number = this.defaultDateTime): boolean {
		if (timestamp > 1457870400 && timestamp < 1478433600) {
			// 13/03/16 <---> 06/11/16
			this.dst = true;
		}
		if (timestamp > 1489320000 && timestamp < 1509883200) {
			// 12/03/17 <---> 05/11/17
			this.dst = true;
		}
		if (timestamp > 1520769600 && timestamp < 1541332800) {
			// 11/03/18 <---> 04/11/18
			this.dst = true;
		}
		if (timestamp > 1552219200 && timestamp < 1572782400) {
			// 10/03/19 <---> 03/11/19
			this.dst = true;
		}
		if (timestamp > 1583668800 && timestamp < 1604232000) {
			// 08/03/20 <---> 01/11/20
			this.dst = true;
		}
		if (timestamp > 1615723200 && timestamp < 1636286400) {
			// 14/03/21 <---> 07/11/21
			this.dst = true;
		}

		console.log('is dst', this.dst);

		return this.dst;
	}

	public convertDateToTimestamp(date: Date): number {
		const day = +date.getDate();
		const month = +date.getMonth();
		const year = +date.getFullYear();

		const hours = +date.getHours();
		const minutes = +date.getMinutes();

		/**
		 * Reset the local time zone of new Date()
		 */
		const UTC = new Date(year, month, day);
		// const userOffset = UTC.getTimezoneOffset();
		// UTC.setHours(hours, (minutes - userOffset));

		const timestamp: number = UTC.getTime() / NUM_MS_IN_ONE_SS;

		return timestamp;
	}

	public padDateTime(num, size) {
		const s = '000000000' + num;
		return s.substr(s.length - size);
	}
}
